export var MEMBER_TYPE;
(function (MEMBER_TYPE) {
    MEMBER_TYPE["\uD655\uC778"] = "\uD655\uC778";
    MEMBER_TYPE["\uC2B9\uC778"] = "\uC2B9\uC778";
    MEMBER_TYPE["\uAD6C\uB9E4\uB2F4\uB2F9\uC790"] = "\uAD6C\uB9E4\uB2F4\uB2F9\uC790";
    MEMBER_TYPE["\uC790\uC7AC\uB2F4\uB2F9\uC790"] = "\uC790\uC7AC\uB2F4\uB2F9\uC790";
})(MEMBER_TYPE || (MEMBER_TYPE = {}));
